import { Attendance } from "@/@types/esus/Attendance";
import { GroupActivityCitizen } from "@/@types/esus/GroupActivityCitizen";
import { esusApi } from "@/services/api";

export type DetailedCitizenAttendancesIndicatorM1Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
	citizenId: number;
};

export class DetailedCitizenAttendancesIndicatorM1Data {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	healthUnitId?: number = 0;
	healthTeamId: number = 0;
	healthTeamIne: string = "";
	healthTeamName: string = "";
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	attendances?: Attendance[];
	groupActivitiesCitizen?: GroupActivityCitizen[];
}

export async function getDetailedCitizenAttendancesIndicatorM1({
	uf,
	ibgeCode,
	...params
}: DetailedCitizenAttendancesIndicatorM1Params) {
	const response = await esusApi.get<DetailedCitizenAttendancesIndicatorM1Data>(
		`/uf/${uf}/city/${ibgeCode}/indicator/emulti/m1/detailed-citizen-attendances`,
		params
	);
	return response.data ?? new DetailedCitizenAttendancesIndicatorM1Data();
}
